import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useNavigate, Navigate } from "react-router-dom";
import { getApiService } from "../services/ApiService";
import '../assets/css/CustomUtility.css'; // This is having invalid feedback and Datepicker related css
import '../assets/css/feather.css';
import '../assets/css/CG.css';
import '../assets/css/Login.css';
import ServiceLinkLogo from '../assets/images/carriers-logo/servicelink-sso.png';
import RegionSelection from '../assets/images/Illustrations/Service.svg';
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';

const Region = () => {

    const navigate = useNavigate();
    const ssoAuthID = Cookies.get('authID');
    const loggedId = ssoAuthID ? JSON.parse(atob(ssoAuthID)) : null;
    const ssoPrcess = process.env.REACT_APP_API_SSO_PROCESS;
    const loginFrom = sessionStorage.getItem('loginFrom');
    const appEnv = process.env.REACT_APP_ENVIRONMENT;

    //Check if authID is present in session storage, if not redirect to SSO Check
    useEffect(() => {

        if (loginFrom === 'Carrier') {
            window.location.href = "/logout";
        } else {
            if (!ssoAuthID && ssoPrcess === 'TRUE') {
                Object.keys(Cookies.get()).forEach(key => Cookies.remove(key)); // Clear all cookies
                localStorage.clear();
                const baseUrl = process.env.REACT_APP_API_BASE_URL;
                const targetUrl = process.env.REACT_APP_API_SSO_CHECK_ENDPOINT;
                window.location.href = `${baseUrl}${targetUrl}`; // Redirect to SSO Check endpoint
            }
        }

    }, [loginFrom, ssoAuthID, ssoPrcess, navigate]);

    const [selectedRegions, setSelectedRegions] = useState();
    const [arrRegions, setArrRegions] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [showRegions, setShowRegions] = useState(false);
    
    //This is for PFIX environment, if the env is PFIX then direct redirect to login page
    useEffect(() => {
        if(appEnv === 'PFIX'){
            Cookies.set('region', process.env.REACT_APP_PFIX_DB2_REGION, getCookieOptions());
            navigate('/login');
        }
    }, [appEnv, navigate]);

    useEffect(() => {
        //Check if user is authenticated, if yes show regions selection
        if(loggedId?.loggedId){
            setShowRegions(true);
        }
        //If SSO process is FALSE then show regions selection, local/dev environment
        if(ssoPrcess === 'FALSE'){
            setShowRegions(true);
        }

    }, [loggedId, ssoPrcess]);

    // Fetch regions from API on component mount
    useEffect(() => {
        const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        };
        const targetUrl = process.env.REACT_APP_API_GET_REGIONS_ENDPOINT;
        getApiService(baseUrl, targetUrl, {}, headers)
            .then((response) => {
                if (response?.data && response?.data?.status == 'SUCCESS') {
                    const result = response.data.data;
                    setArrRegions(response.data.data);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [baseUrl]);

    // Handle change event for region selection
    const handleChange = (e) => {
        setSelectedRegions(e.target.value);
        Cookies.set('region', e.target.value, getCookieOptions());
        navigate('/login');
    }

    // Don't render the component until showRegions is true
    if(!showRegions){
        return(
         <div>
            <div className="container">
                 <div className="row">
                     <div className="col-12 text-center">
                         <h1 className="mt-5">Redirecting...</h1>
                         <p>Please wait while we redirect you to the appropriate page.</p>
                     </div>
                 </div>
             </div>
         </div>
        )
     }

    if(showRegions === true){
    return (
        <>
            <div className="container-fluid p-0">
                <section className="min-vh-100 d-flex justify-content-center">
                    <div className="row justify-content-center w-100">
                        <div className="col-12 col-xxl-11 px-0">
                            <div style={{ background: '#fff' }} className="border-light-subtle mb-0 h-100">
                                <div className="row g-0 h-100">
                                    {/* Image Section - Full height on all screens */}
                                    <div className="col-12 col-md-6 overlay-sl p-0 d-flex align-items-center justify-content-end">
                                        <img
                                            src={RegionSelection}
                                            alt="Payment-mobile"
                                            className="mw-90 mt-5 pb-4"
                                        />
                                    </div>

                                    {/* Form Section */}
                                    <div className="col-12 col-md-6 d-flex mt-4 justify-content-center">
                                        <div className="col-12 col-lg-11 col-xl-10">
                                            <div className="card-body p-3 p-md-4 p-xl-3">
                                                <div className="row">
                                                    <div className="col-12 d-flex flex-column flex-sm-row">
                                                        <div className="col-12 col-sm-6">
                                                            <img src={ServiceLinkLogo} className="mb-2" width="200" alt="servicelogo" />
                                                        </div>
                                                        <div className="col-12 col-sm-6 text-sm-end">
                                                            <h2 className="text-left fw-semibold primary-color">
                                                                SSO Simulation
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Form className="needs-validation">
                                                    <div className="row gy-3 overflow-hidden mt-0">
                                                        <div className="member-SLP mt-4">
                                                            <h3 style={{ fontSize: '1.5rem' }} className="text-left fw-semibold primary-color mb-3 pb-2">
                                                                Select Region
                                                            </h3>
                                                            <div className="col-12">
                                                                <div className="mb-1">
                                                                    <Form.Group>
                                                                        <Form.Select
                                                                            className="form-login-select form-login-control"
                                                                            defaultValue="Choose Regions"
                                                                            name="regions"
                                                                            id="regions"
                                                                            value={selectedRegions}
                                                                            onChange={handleChange}
                                                                        >
                                                                            <option>Choose...</option>
                                                                            {
                                                                                arrRegions && arrRegions?.map((item) =>
                                                                                    <option value={item?.id}>{item?.id + " - " + item?.name}</option>
                                                                                )
                                                                            }
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
    }
};

export default Region;